import { action } from 'satcheljs/lib/legacy';
import { ClientAttachmentId } from 'owa-client-ids';
import { userDate } from 'owa-datetime';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import setAttachmentPermissionLevel from './setAttachmentPermissionLevel';
import setAttachmentPermissionsService from '../services/setAttachmentPermissionsService';

export default action('changeAttachmentPermission')(async function changeAttachmentPermission(
    attachmentIds: ClientAttachmentId[],
    permissionLevel: AttachmentPermissionLevel,
    newAttachLongPathNames: string[] = null,
    setToOriginalPermissionLevel: boolean = false
): Promise<void> {
    const response = await setAttachmentPermissionsService(
        attachmentIds.map(attachmentId => attachmentId.Id),
        permissionLevel,
        newAttachLongPathNames,
        setToOriginalPermissionLevel
    );

    if (
        !response.OperationSucceeded ||
        !response.NewAttachLongPathNames ||
        response.NewAttachLongPathNames.length !== attachmentIds.length
    ) {
        throw new Error('Error setting attachment permissions');
    }

    attachmentIds.forEach((attachmentId, index) => {
        let expirationDate = null;
        if (response.ExpirationDates?.[index]) {
            expirationDate = userDate(response.ExpirationDates[index]);
        }
        setAttachmentPermissionLevel(
            attachmentId,
            permissionLevel,
            response.NewAttachLongPathNames[index],
            expirationDate
        );
    });
});
